// @ts-nocheck
import { UserColor } from '../../const/UserColors';
import { adjustFontSizeAvatar } from '../../helpers/UserIntialsHelper';
import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { useProbeProfilePhotoQuery } from '../../../../media/api/mediaProbeApi';
import { store as kanbanStore } from '../../store';
import { useNearViewport } from '../../hooks/useNearViewport';
import { useAuthenticatedImage } from '../../../../../hooks/useAuthenticatedImage';
import { buildProfilePhotoThumbnailUrl } from '../../../../profile-photo/profilePhotoThumbnailUrl';

type AvatarProps = {
  initials: string;
  relationId?: number;
  className?: string;
  colorKey?: string;
  hasProfilePhoto?: boolean;
  profilePhotoUrl?: string | null;
  deferProfilePhoto?: boolean;
};

const AvatarContent: React.FC<AvatarProps> = ({
  initials,
  relationId,
  className = 'comment__user-icon kanban-card__avatar',
  colorKey = initials,
  hasProfilePhoto,
  profilePhotoUrl,
  deferProfilePhoto = false,
}) => {
  const [failedPhotoUrl, setFailedPhotoUrl] = useState<string | null>(null);
  const hasProvidedPhotoUrl = profilePhotoUrl !== undefined;
  const providedPhotoUrl = profilePhotoUrl?.trim() || null;
  const canLoadProfilePhoto =
    !hasProvidedPhotoUrl &&
    Boolean(relationId) &&
    (hasProfilePhoto === true || (hasProfilePhoto !== false && !deferProfilePhoto));
  const shouldObserveAvatar =
    Boolean(providedPhotoUrl) ||
    canLoadProfilePhoto ||
    (hasProvidedPhotoUrl && hasProfilePhoto === true);
  const { elementRef: avatarRef, isNearViewport } =
    useNearViewport<HTMLDivElement>(shouldObserveAvatar);

  const shouldProbeProfilePhoto = canLoadProfilePhoto && isNearViewport;
  const profilePhotoQuery = useProbeProfilePhotoQuery(relationId ?? 0, {
    skip: !shouldProbeProfilePhoto,
  });
  const originalUrl = providedPhotoUrl ?? profilePhotoQuery.data?.resolvedUrl ?? null;
  const photoUrl = isNearViewport
    ? buildProfilePhotoThumbnailUrl(
        relationId,
        hasProfilePhoto === true || (hasProfilePhoto !== false && Boolean(originalUrl)),
        originalUrl
      )
    : null;
  const authenticatedPhotoUrl = useAuthenticatedImage(photoUrl);
  const shouldShowPhoto = Boolean(authenticatedPhotoUrl) && failedPhotoUrl !== photoUrl;

  return (
    <div
      ref={avatarRef}
      className={className}
      style={{
        backgroundColor: UserColor.getColor(colorKey).backgroundColor,
        border: `2px solid ${UserColor.getColor(colorKey).borderColor}`,
        fontSize: `${adjustFontSizeAvatar(initials.length)}px`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {initials}
      {shouldShowPhoto && (
        <img
          src={authenticatedPhotoUrl ?? undefined}
          alt="Profile photo"
          loading="lazy"
          decoding="async"
          onError={() => setFailedPhotoUrl(photoUrl)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
    </div>
  );
};

const Avatar: React.FC<AvatarProps> = (props) => (
  <Provider store={kanbanStore}>
    <AvatarContent {...props} />
  </Provider>
);

export default Avatar;
